module.exports = __webpack_public_path__ + "img/skoda-logo.c4f17b5d.png";